import React, { useState } from 'react'
import {
  ButtonsContainer,
  Card,
  CardContent,
  Description,
  ReturnButton,
  SubmitButton,
  SubmitDisclaimer,
  Title
} from './styles'
import { LikertScale } from '../LikertScale'
import { message } from '~/services'
import { Divider } from '~/styles'

interface NPSCardProps {
  onClose: () => void
  onSubmit: (npsValue: number) => void
}

export const NPSCard = ({ onClose, onSubmit }: NPSCardProps): JSX.Element => {
  const [npsValue, setNpsValue] = useState<number | undefined>(undefined)

  return (
    <Card>
      <Title>{message('feedback.help_us')}</Title>

      <CardContent>
        <Description>{message('feedback.npsResponseText')}</Description>
        <LikertScale npsValue={npsValue} onChange={e => setNpsValue(Number(e.currentTarget.value))} />

        <Divider />
        <SubmitDisclaimer>{message('feedback.submit_disclaimer')}</SubmitDisclaimer>

        <ButtonsContainer>
          <ReturnButton onClick={onClose} />
          <SubmitButton disabled={npsValue === undefined} onClick={() => npsValue && onSubmit(npsValue)} />
        </ButtonsContainer>
      </CardContent>
    </Card>
  )
}
